import { createTheme } from "@mui/material/styles";
import { AppName } from "./utils/constants";
declare module "@mui/material/styles" {
  interface Palette {
    greyColors: Palette["primary"] & { shadow?: string };
    blueColors: Palette["primary"];
    calenderColors: Palette["primary"];
    dropdownHighlight: Palette["primary"];
    tableHighlight: Palette["primary"];
    drawerHover: Palette["primary"];
  }
  interface PaletteOptions {
    greyColors?: PaletteOptions["primary"] & { shadow?: string };
    blueColors?: PaletteOptions["primary"];
    calenderColors?: PaletteOptions["primary"];
    dropdownHighlight?: PaletteOptions["primary"];
    tableHighlight?: PaletteOptions["primary"];
    drawerHover?: PaletteOptions["primary"];
  }
}
export const faunaTheme = createTheme({
  palette: {
    primary: {
      main: "#39B54A",
      dark: "#79d2a6",
      light: "#adebad",
    },
    secondary: {
      main: "#ffff",
      dark: "#000000",
      light: "#4CAF50",
    },
    success: {
      main: "#39B54A",
      light: "#88D392",
    },
    info: {
      main: "rgb(200, 93, 83)",
      light: "rgb(146, 201, 239)",
      dark: "#D9D9D9",
    },
    error: {
      main: "rgb(200, 93, 83)",
      dark: "#D11414"
    },
    greyColors: {
      main: "#F0ECEC",
      dark: " #525252",
      light: "#EDEAEA",
      contrastText: "#FEFEFE",
      shadow: "#F0EDFF"
    },
    blueColors: {
      main: "#2B2A5C",
    },
    calenderColors: {
      main: "#4CAF50",
      light: "#45a049",
    },
    dropdownHighlight: {
      main: "#4CAF50",
      contrastText: "",
    },
    tableHighlight: {
      main: "#4CAF50",
    },
    drawerHover: {
      main: "#adebad",
    },
  },
  typography: {
    fontFamily: 'Nunito Sans Regular500',
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
  },
});

export const bioTheme = createTheme({
  palette: {
    primary: {
      main: "#0C6F70",
      dark: "#509d8c",
      light: "#88B3E0",
    },
    secondary: {
      main: "#ffff",
      dark: "#000000",
      light: "#87ac55",
    },
    success: {
      main: "#39B54A",
      light: "#88D392",
    },
    info: {
      main: "rgb(200, 93, 83)",
      light: "#C0DCF5",
      dark: "#D9D9D9",
    },
    error: {
      main: "rgb(200, 93, 83)",
      dark: "#D11414"
    },
    greyColors: {
      main: "#F0ECEC",
      dark: " #525252",
      light: "#EDEAEA",
      contrastText: "#FEFEFE",
      shadow: "#E5F3FD"
    },
    blueColors: {
      main: "#0C6F70",
      light: "#63c2d0",
    },
    calenderColors: {
      main: "#0C6F70",
      light: "#0C6F70",
    },
    dropdownHighlight: {
      main: "#0C6F70",
      contrastText: "#ffff",
    },
    tableHighlight: {
      main: "#0C6F70",
    },
    drawerHover: {
      main: "#509d8c",
    },
  },
  typography: {
    fontFamily: 'Nunito Sans Regular500',
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
  },
});

export const bioAssistTheme = createTheme({
  palette: {
    primary: {
      main: "#4E5052",
      dark: "#c1c3c5",
      light: "#c1c3c5",
    },
    secondary: {
      main: "#ffff",
      dark: "#000000",
      light: "#c1c3c5",
    },
    success: {
      main: "#39B54A",
      light: "#88D392",
    },
    info: {
      main: "rgb(200, 93, 83)",
      light: "#C0DCF5",
      dark: "#D9D9D9",
    },
    error: {
      main: "rgb(200, 93, 83)",
      dark: "#D11414"
    },
    greyColors: {
      main: "#F0ECEC",
      dark: " #525252",
      light: "#EDEAEA",
      contrastText: "#FEFEFE",
      shadow: "#E5F3FD"
    },
    blueColors: {
      main: "#4E5052",
      light: "#c1c3c5",
    },
    calenderColors: {
      main: "#c1c3c5",
      light: "#c1c3c5",
    },
    dropdownHighlight: {
      main: "#c1c3c5",
      contrastText: "",
    },
    tableHighlight: {
      main: "#c1c3c5",
    },
    drawerHover: {
      main: "#c1c3c5",
    },
  },
  typography: {
    fontFamily: 'Nunito Sans Regular500',
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
  },
});

export const faunaViewerTheme = createTheme({
  palette: {
    primary: {
      main: "#96A27E",
      dark: "#5B5A50",
      light: "#C9CFBC",
    },
    secondary: {
      main: "#ffff",
      dark: "#000000",
      light: "#C9CFBC",
    },
    success: {
      main: "#39B54A",
      light: "#88D392",
    },
    info: {
      main: "rgb(200, 93, 83)",
      light: "#C0DCF5",
      dark: "#D9D9D9",
    },
    error: {
      main: "rgb(200, 93, 83)",
      dark: "#D11414",
    },
    greyColors: {
      main: "#F0ECEC",
      dark: " #525252",
      light: "#EDEAEA",
      contrastText: "#FEFEFE",
      shadow: "#F0EDFF",
    },
    blueColors: {
      main: "#5B5A50",
      light: "#5B5A50",
    },
    calenderColors: {
      main: "#5B5A50",
      light: "#5B5A50",
    },
    dropdownHighlight: {
      main: "#C9CFBC",
      contrastText: "",
    },
    tableHighlight: {
      main: "#96A27E",
    },
    drawerHover: {
      main: "#C9CFBC",
    },
  },
  typography: {
    fontFamily: "Nunito Sans Regular500",
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
  },
});

export const FaunaBeheerTheme = createTheme({
  palette: {
    primary: {
      main: "#1B2959",
      dark: "#121C3D",
      light: "#374a6a",
    },
    secondary: {
      main: "#ffff",
      dark: "#000000",
      light: "#94ACD6",
    },
    success: {
      main: "#39B54A",
      light: "#88D392",
    },
    info: {
      main: "rgb(200, 93, 83)",
      light: "#C0DCF5",
      dark: "#D9D9D9",
    },
    error: {
      main: "rgb(200, 93, 83)",
      dark: "#D11414"
    },
    greyColors: {
      main: "#F0ECEC",
      dark: " #525252",
      light: "#EDEAEA",
      contrastText: "#FEFEFE",
      shadow: "#EAEFF8"
    },
    blueColors: {
      main: "#1B2959",
      light: "#2b3e5e",
    },
    calenderColors: {
      main: "#1B2959",
      light: "#2E4180",
    },
    dropdownHighlight: {
      main: "#94ACD6",
      contrastText: "",
    },
    tableHighlight: {
      main: "#94ACD6",
    },
    drawerHover: {
      main: "#374a6a",
    },
    action: {
      disabled: "#a7a4a4",
    },
  },
  typography: {
    fontFamily: 'Nunito Sans Regular500',
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
  },
});

export const themeMap: Record<AppName, ReturnType<typeof createTheme>> = {
  [AppName.FaunaProtect]: faunaTheme,
  [AppName.BioEcologie]: bioTheme,
  [AppName.EcoAssist]: bioAssistTheme,
  [AppName.FaunaBeheer]: FaunaBeheerTheme,
  [AppName.FaunaViewer]: faunaViewerTheme,
};

const themeEnv = themeMap[(import.meta.env.VITE_APP_NAME as AppName)] ?? faunaTheme;
export default themeEnv;
